import {
  Box,
  Button,
  Skeleton,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import ReturnLink from './ReturnLink';

const PREFIX = 'PageHeader';

const classes = {
  container: `${PREFIX}-container`,
  row: `${PREFIX}-row`,
  editButton: `${PREFIX}-edit-button`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 0,
  },

  [`&.${classes.editButton}`]: {
    minWidth: 144,
  },
}));

interface PageHeaderProps {
  title: string;
  returnLink?: string;
  returnLinkText?: string;
  primaryActionText?: string;
  primaryActionDisabled?: boolean;
  primaryActionClassName?: string;
  primaryActionDataFsElement?: string;
  onPrimaryAction?: () => void;
  showReturnLinkPlaceholder?: boolean;
}

const PageHeader = ({
  title,
  returnLink,
  returnLinkText,
  primaryActionText,
  primaryActionDataFsElement,
  primaryActionDisabled = false,
  primaryActionClassName = '',
  onPrimaryAction = undefined,
  showReturnLinkPlaceholder = false,
}: PageHeaderProps) => {
  const hasReturnLinkData = returnLink && returnLinkText;
  return (
    <StyledBox className={classes.container}>
      <Stack direction="column">
        {hasReturnLinkData && (
          <ReturnLink returnLink={returnLink} returnLinkText={returnLinkText} />
        )}
        {showReturnLinkPlaceholder && !hasReturnLinkData && (
          <Skeleton sx={{ fontSize: 14, lineHeight: '24px', maxWidth: 150 }} />
        )}

        <Typography variant="h2">
          {title ? title : <Skeleton animation="wave" sx={{ minWidth: 200 }} />}
        </Typography>
      </Stack>
      {primaryActionText && onPrimaryAction && (
        <Button
          className={`${classes.editButton} ${primaryActionClassName}`}
          variant="contained"
          disabled={primaryActionDisabled}
          onClick={onPrimaryAction}
          data-fs-element={primaryActionDataFsElement}>
          {primaryActionText}
        </Button>
      )}
    </StyledBox>
  );
};

export default PageHeader;
